<template>
  <div
    class="build-version-wrapper"
    @mouseover="showBuildVersion(true)"
    @mouseleave="showBuildVersion(false)"
  >
    <slot />
    <no-ssr>
      <transition name="fade">
        <div
          v-if="displayBV"
          class="build-version"
        >
          <div
            class="inner"
            data-cy="build-version-hover"
          >
            <div class="build-version-text item">
              <div class="label">
                Build Version
              </div>
              <div class="value">
                {{ buildversion }}
              </div>
            </div>
            <div class="build-date-text item">
              <div class="label">
                Build Date
              </div>
              <div class="value">
                {{ buildDate }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </no-ssr>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'build-version',
  data() {
    return {
      hover: false,
      metaKey: false,
      showVersion: false
    }
  },
  computed: {
    displayBV() {
      return (this.hover && this.metaKey) || this.showVersion
    },
    buildversion() {
      return process.env.BUILDVERSION
    },
    buildDate() {
      return dayjs(new Date(process.env.BUILDDATE)).format('ddd, DD MMM YYYY hh:mm a')
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      let buildVersionPending = false
      let keyShortcutTimer = null
      let metaKeyTimer = null

      window.addEventListener('keydown', evt => {
        if (evt.key === 'Meta') {
          metaKeyTimer = setTimeout(() => {
            this.metaKey = true
          }, 2000)
        }
      })
      window.addEventListener('keyup', evt => {
        if (typeof event.getModifierState !== 'function') {
          return
        }

        if (evt.key === 'Meta') {
          if (metaKeyTimer) {
            clearTimeout(metaKeyTimer)
            metaKeyTimer = null
          }
          this.metaKey = false
        }
        if (buildVersionPending && evt.key === 'v' && evt.getModifierState('Control')) {
          if (keyShortcutTimer) {
            clearTimeout(keyShortcutTimer)
          }
          this.showVersion = true
          setTimeout(() => {
            this.showVersion = false
          }, 2500)
          buildVersionPending = false
        }
        else if (evt.key === 'b' && evt.getModifierState('Control')) {
          buildVersionPending = true
          keyShortcutTimer = setTimeout(() => {
            buildVersionPending = false
          }, 1000)
        }
      })

      window.addEventListener('blur', evt => {
        if (metaKeyTimer) {
          clearTimeout(metaKeyTimer)
          metaKeyTimer = null
        }
        this.metaKey = false
      })
    }
  },
  methods: {
    showBuildVersion(state) {
      this.hover = state
    }
  }
}
</script>

<style lang='scss' scoped>

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.build-version-wrapper {
  position: relative;
  .build-version {
    .inner {
      width: 450px;
      position: absolute;
      top: 0;
      left: 0;
      background-color: white;
      padding: 1em;
      color: black;
      border: 1px solid rgba(0, 0, 0, 0.3);

      .item {
        display: flex;
        justify-content: left;

        .label {
          width: 120px;
        }
      }
    }
  }
}

</style>
